import * as React from 'react';

import { cn } from '../lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'h-10 w-full min-w-0 rounded-lg border border-input bg-transparent px-3 py-2 [font-size:var(--text-body)] [line-height:var(--text-body--line-height)] transition-[background-color,border-color] duration-150 outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:[font-size:var(--text-body-sm)] file:[line-height:var(--text-body-sm--line-height)] file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-surface-hover disabled:opacity-40 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  );
}

export { Input };
